export default {}



// WEBPACK FOOTER //
// ./src/store/modules/contact/getters.js